import AxiosService from './AxiosService'

class ProxyRestService {
  getConfigs(): Promise<any> {
    return AxiosService.get('/proxy/configs')
  }

  getConfigById(id: number): Promise<any> {
    return AxiosService.get('/proxy/configs/' + id)
  }

  create(proxy: any): Promise<any> {
    return AxiosService.post('/proxy/configs', proxy)
  }

  update(proxy: any): Promise<any> {
    return AxiosService.put('/proxy/configs/' + proxy.id, proxy)
  }

  delete(id: number): Promise<any> {
    return AxiosService.delete('/proxy/configs/' + id)
  }

  getAssignedApps(id: number): Promise<any> {
    return AxiosService.get('/proxy/configs/' + id + '/apps')
  }

  updateAssignedApps(id: number, apps: any[]): Promise<any> {
    return AxiosService.put('/proxy/configs/' + id + '/apps', apps)
  }

  getRuntimes(): Promise<any> {
    return AxiosService.get('/proxy/runtimes')
  }

  getRuntimesById(id: number): Promise<any> {
    return AxiosService.get('/proxy/runtimes/' + id)
  }

  startProxy(id: number): Promise<any> {
    return AxiosService.put('/proxy/runtimes/' + id + '/start')
  }

  restartProxy(id: number): Promise<any> {
    return AxiosService.put('/proxy/runtimes/' + id + '/restart')
  }

  stopProxy(id: number): Promise<any> {
    return AxiosService.put('/proxy/runtimes/' + id + '/stop')
  }
}

export default new ProxyRestService()
